<template>
  <b-modal
    id="deleterefundpayment"
    size="sm"
    ref="deleterefundpayment"
    body-class="bg-white"
    cancel-title="close"
    cancel-variant="light"
    :ok-title-html="submitted==true?loaderIcon+'Yes':'Yes'"
    :no-close-on-backdrop="true"
    title="Delete Applied Refund"
    @ok="deleterefundpaymentrecord"
  >
    <p>Are you sure about deleting the refund made?</p>
  </b-modal>
</template>

<script>
export default {
  data() {
    return {
      loaderIcon: `<i class="fa fa-circle-o-notch fa-spin mr-2"></i>`,
      submitted: false
    };
  },
  props: ["RefundDeleteDetail", "page"],
  name: "DeleteRefundRecord",
  methods: {
    deleterefundpaymentrecord() {
      this.submitted = true;
      this.$store
        .dispatch(
          this.page + "/deleteRefund",
          this.RefundDeleteDetail.applied_id
        )

        .then(response => {
          this.submitted = false;
          if(response.data.code==200){
          this.$emit("setRefundAmountDetails", {
            RefundDeleteDetail: this.RefundDeleteDetail,
            code:response.code
          });
          }else{
             this.$emit("recallRecord",response)
          }
           window.Messenger().post({
            extraClasses:
              "messenger-fixed messenger-on-top messenger-on-center",
             message: response.data.status,
            type: response.data.type,
            showCloseButton: true,
          });
        });
    }
  }
};
</script>

<style>
</style>
